import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { SiaAction } from '../interfaces/sia-action';
import { SiaActionBaseData } from '../interfaces/sia-action-base-data';
import { SiaItemAction } from '../interfaces/sia-item-action';
import { SiaItemWithActions } from '../interfaces/sia-item-with-actions';

@Injectable({
  providedIn: 'root',
})
export class SiaActionsApi {
  private api = inject(SiaHttpService);

  private readonly actionsController: string = 'actions';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getActionsByComponent(
    componentId: string,
    mode?: string,
  ): Promise<SiaAction[]> {
    let params = new HttpParams();
    if (mode) {
      params = params.set('mode', mode);
    }
    return this.api.get(`${this.actionsController}/${componentId}`, {
      params,
    });
  }

  getItemWithActions(): Promise<SiaItemWithActions[]> {
    return this.api.get(`${this.actionsController}/items-with-actions`, {});
  }
  getActionsByItemAndType(id: string, type?: string) {
    let params = new HttpParams();
    params = params.set('type', type ?? '');
    return this.api.get(`${this.actionsController}/${id}/with-types`, {
      params,
    });
  }

  getActions(): Promise<SiaActionBaseData[]> {
    return this.api.get(`${this.actionsController}`, {});
  }

  saveActions(
    actions: SiaItemAction[],
    id: string,
    isGroup: boolean,
  ): Promise<boolean> {
    let item = { id: id, actions: actions, isGroup: isGroup };
    return this.api.put(`${this.actionsController}`, item);
  }

  renameActions(actions: SiaItemAction[], id: string, group: boolean) {
    let item = { id: id, actions: actions, isGroup: group };
    return this.api.post(`${this.actionsController}`, item);
  }

  savePageActionConfiguration(
    id: string,
    masterConf: string,
    mobileConf: string,
  ) {
    let item = {
      id: id,
      masterConf: masterConf,
      mobileConf: mobileConf,
    };
    return this.api.put(`${this.actionsController}/configurations`, item);
  }
}
